import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "../ui/Tooltip";

export default function TransmissionLineTooltip({ name, voltage, id, isOpen, style }: { name: string, voltage: string, id: string, isOpen: boolean, style?: React.CSSProperties }) {
    return (
        <TooltipProvider>
            <Tooltip delayDuration={200} open={isOpen}>
                <TooltipTrigger asChild>
                    <div className="mb-2" style={{ width: "100%", height: "100%", cursor: "pointer", background: "transparent" }} />
                </TooltipTrigger>
                <TooltipContent
                    forceMount
                    className="bg-white dark:bg-[#2D3748] rounded-md"
                    style={style}
                    side="top"
                >   
                    <div className="flex flex-col min-w-[200px] w-full py-1.5">
                        <div className="flex justify-between mb-1.5">
                            <p className="text-xs font-bold text-[#535353] dark:text-[#D9D9D9] truncate max-w-[70%]">{!id || id === "N/A" ? "N/A" : id}</p>
                            <p className="text-xs font-bold text-[#535353] dark:text-[#D9D9D9]">{voltage}</p>
                        </div>
                        <div className="flex flex-col">
                            <p className="text-xs font-normal text-[#535353] dark:text-[#CEE0EF]">{!name || name === "Not Available" ? "N/A" : name.toUpperCase()}</p>
                        </div>               
                    </div>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
